<atx-aside-menu
  [open]="opened$ | async"
  placement="right"
  [useOverlay]="true"
  [backdropClass]="backdropClass$ | async"
  [rootClass]="className$ | async"
  (openStateChange)="onOpenStateChanged($event)"
>
  @if (showCloseButton$ | async) {
  <div class="menu-title position-absolute w-100">
    <div class="d-flex flex-row justify-content-start p-3">
      <button
        class="btn btn-round btn-light"
        (click)="onCloseClicked()"
        data-e2e="user-menu-close"
      >
        <fa-icon [icon]="['fas', 'xmark']" size="xs"></fa-icon>
      </button>
      @if (title$ | async; as title) {
      <h3 class="ml-3 h3">{{ title }}</h3>
      }
    </div>
  </div>
  }
  <div class="menu-content h-100">
    @if (content$ | async; as content) {
    <epc-dynamic-collections-outlet [items]="content">
    </epc-dynamic-collections-outlet>
    }
  </div>
</atx-aside-menu>
